import type { $Fetch, NitroFetchRequest } from "nitropack"

/**
 * Repository for application-related API calls
 */
export function applicationRepository<T>(fetch: $Fetch<T, NitroFetchRequest>) {
  return {
    /**
     * Send a job application
     *
     * @param tenantId The tenant ID
     * @param jobShopLocale The job shop locale for Accept-Language header
     * @param applicationData The application data to send
     * @returns Response from the Candidate Service
     */
    async sendApplication(tenantId: string, jobShopLocale: string, applicationData: ApplicationRequest) {
      // Note: We add /public only in dev because nginx on stage & prod automatically redirects to /public
      const response = await fetch(`${UrlConfig.PATH_BASE_CANDIDATE_SERVICE}${import.meta.dev ? "/public" : ""}/application/create`, {
        method: "POST",
        headers: {
          "Accept-Language": jobShopLocale,
          "Accept": "application/json",
          "Content-Type": "application/json",
          "X-Tenant-Id": tenantId,
        },
        body: applicationData,
      })

      return response
    }
  }
}
